import React, { useEffect } from "react";
import "./lightBoxStyle.scss"; 

const LightBox = ({ show = true, onClose, children, width = "30vw" , title}) => {

    useEffect(() => {
        if (show) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [show]);

    return (
        <>
            {/* Backdrop */}
            {show && <div className="offcanvas-backdrop" onClick={onClose} />}

            {/* Slide-in panel */}
            <div className={`offcanvas-panel ${show ? "show" : ""}`} style={{ width }}>
                <div className="d-flex position-sticky top-0 justify-content-between px-3 py-3" >
                    <h4>{title}</h4>
                    <button className="offcanvas-close" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="offcanvas-content">{children}</div>
            </div>
        </>
    );
};

export default LightBox;
